import baseSearchOptions from 'vue-src/store/modules/persistent/modules/_baseSearchOptions'

export default baseSearchOptions({
  state:{
    sort:'product_name',
  },
})


// WEBPACK FOOTER //
// ./ixcms/themes/heartlandtan/src/vue-src/store/modules/persistent/modules/mxcategoryItems.js